import React from "react";
import { ButtonDelete } from "../../common/Buttons";
import { BulkRowCheckbox } from "../../common/BulkSelection";

function TableColumnBlacklist({ item, index, selection, onDelete }) {
  const date = (item.updated_at || item.created_at || "").toString().slice(0, 10);
  const defaultOrdersFilters = {
    id: "",
    client: "",
    customer_email_exact: "",
    payer: "",
    date: ["", ""],
    supp_date: ["", ""],
    without_shipping: "",
    payment: "",
    payment_reference: "",
    order_row: "",
    delivery: undefined,
    order_shops: undefined,
    total_price_to: "",
    total_price_from: "",
    statusFilter: [],
    categoryFilter: [],
    comment: "",
    comment_state: [],
    serialNumber_check: false,
    serialNumber_switch: false,
    assigned_bills_check: false,
    assigned_bills_switch: false,
    with_errors_check: "",
    with_tax_free: false,
    at_the_store: undefined,
    invoice_email_state: undefined,
    urgents: false,
    supplier: undefined,
    supplier_ids: [],
    user_suppliers: [],
    invoice_api_errors: false,
    ship_api_errors: false,
    carrying: false,
    shipment_type: undefined,
    shipments_created_at: ["", ""],
  };

  const openOrders = () => {
    try {
      localStorage.setItem(
        "orders_filters",
        JSON.stringify({
          ...defaultOrdersFilters,
          customer_email_exact: item.email,
        })
      );
    } catch (_) {}
    window.open(
      `/orders?customer_email_exact=${encodeURIComponent(item.email || "")}`,
      "_blank"
    );
  };

  return (
    <tr className="align-middle tableColumn" key={index}>
      <td className="align-middle">
        <BulkRowCheckbox selection={selection} id={item.id} />
      </td>
      <td className="align-middle">{item.id}</td>
      <td className="align-middle">{item.email}</td>
      <td className="align-middle">{item.firstname}</td>
      <td className="align-middle">{item.lastname}</td>
      <td className="align-middle">{item.phone}</td>
      <td className="align-middle">{item.company_code}</td>
      <td className="align-middle">{date}</td>
      <td className="align-middle">{item.order_shops}</td>
      <td className="align-middle">{item.blacklist_reason}</td>
      <td className="align-middle">
        {item.orders_count > 0 ? (
          <span
            onClick={openOrders}
            style={{ cursor: "pointer", color: "#1890ff", textDecoration: "underline" }}
          >
            {item.orders_count}
          </span>
        ) : (
          item.orders_count
        )}
      </td>
      <td className="align-middle" style={{ width: "50px" }}>
        <ButtonDelete onDelete={() => onDelete(item.id)} />
      </td>
    </tr>
  );
}

export default TableColumnBlacklist;
